import React, {useEffect, useRef} from "react";
import "./SappmModal.css";

export default function SappmModal({open, onClose, onLearnMore}) {
    const modalRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        modalRef.current?.focus();
    }, [open]);

    useEffect(() => {
        if (!open) return;

        function handleKeyDown(e) {
            if (e.key === "Escape") onClose();
        }
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="sappm-modal-overlay" onClick={onClose}>
            <div
                className="sappm-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="sappm-modal-title"
                tabIndex={-1}
                ref={modalRef}
                onClick={e => e.stopPropagation()}
            >
                <button className="sappm-modal-close" onClick={onClose} aria-label="Fermer">✕</button>
                <p id="sappm-modal-title" className="sappm-modal-hook">
                    On vous a appris à servir l'intérêt général. Personne ne vous a dit qui veillerait sur le vôtre.
                </p>
                <p className="sappm-modal-body">
                    Le SAPPM défend les agents des SPM — pas seulement leurs dossiers, mais leur dignité et leur santé au travail.
                </p>
                <button className="sappm-modal-cta" onClick={onLearnMore}>En savoir plus →</button>
            </div>
        </div>
    );
}
